export enum ContentLibrarySortEnum {
    NAME = 'FILE_NAME',
    UPLOADED_DATE = 'UPLOADED_DATE',
    FILE_SIZE = 'FILE_SIZE'
}
